import type { WorkflowMarkdown } from '../../types';
import { api } from '../../utils/api';

export function fetchOne({
  oid,
  pid,
  wid,
  repo,
  version,
}: {
  oid: string;
  pid: string;
  wid: string;
  repo: string;
  version: string | undefined;
}) {
  let url = `/orgs/${oid}/${pid}/workflows/docs/${repo}/${wid}`;
  version && (url += `?version=${version}`);

  return api.get<WorkflowMarkdown>(url).then(({ data }) => data);
}
